import { render, staticRenderFns } from "./LeadBoardDeleteColumnModal.vue?vue&type=template&id=25f852d1&"
import script from "./LeadBoardDeleteColumnModal.vue?vue&type=script&lang=js&"
export * from "./LeadBoardDeleteColumnModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports